import { render, staticRenderFns } from "./SafetyCard.vue?vue&type=template&id=5702fee2&"
import script from "./SafetyCard.vue?vue&type=script&lang=js&"
export * from "./SafetyCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports